import { Button } from "@/components/ui/button";
import { getQuotePdfUrl } from "@/lib/quotes";

export function QuotePdfLink({ quoteId }: { quoteId: number }) {
  return (
    <Button asChild variant="outline" size="sm">
      <a href={getQuotePdfUrl(quoteId)} target="_blank" rel="noopener noreferrer">
        Download PDF
      </a>
    </Button>
  );
}
